export const POINTS_LABELS_FRAGMENT = `{
  inputTitle
  abbr
  inputSubtitle
}`
